/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { User, Clock, Categories } from "ceicons";
import DifficultyRate from "../DifficultyRate";
import { createFragmentContainer } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import { Grid, Image } from "semantic-ui-react";
import PillWithButton from "../../PillWithButton";
import { map } from "lodash";
import "./recipeInfo.scss";

function RecipeInfo({ recipe }) {
  const t = useTranslation();
  const actualRecipeImage =
    !!recipe.mediaFiles.edges.length && recipe?.mediaFiles.edges[0].node;

  const totalMinutes = () => {
    if (recipe.time !== "0") {
      const time = recipe.time.split(":");
      const hourMinutes = parseInt(time[0] * 60, 10);
      const minutes = parseInt(time[1], 10);

      const totalMinutes = hourMinutes + minutes;

      return totalMinutes;
    }

    return recipe.time;
  };

  return (
    <Grid className="recipeinfo-container">
      <Grid.Row columns={2}>
        <Grid.Column>
          {actualRecipeImage.mediaUrl && (
            <Image
              className="recipe-image"
              src={actualRecipeImage.mediaUrl}
              size="large"
            />
          )}
        </Grid.Column>

        <Grid.Column>
          <div className="header-title-stars">
            <h2 className="title-recipe">{recipe.name}</h2>
            <DifficultyRate difficulty={recipe.difficulty} />
          </div>

          <div className="metas">
            {recipe?.serves && (
              <div className="meta-info">
                <div>
                  <User />
                </div>
                <p>
                  {recipe.serves} {t("meta.persons")}
                </p>
              </div>
            )}

            {recipe?.time && (
              <div className="meta-info">
                <div>
                  <Clock />
                </div>
                <p>
                  {totalMinutes()} {t("meta.minutes")}
                </p>
              </div>
            )}

            {recipe?.category?.name && (
              <div className="meta-info">
                <div>
                  <Categories />
                </div>
                <p> {recipe.category.name}</p>
              </div>
            )}
          </div>
          {recipe?.description && (
            <div className="description">
              <p>{recipe.description}</p>
            </div>
          )}

          {!!recipe?.labels.edges.length && (
            <div className="labels-container">
              <p>{t("title.labels")}:</p>
              <div className="label-list">
                {map(recipe.labels.edges, (label, index) => (
                  <PillWithButton
                    key={`recipe-label-${index}`}
                    pill={label.node.name}
                  />
                ))}
              </div>
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default createFragmentContainer(RecipeInfo, {
  recipe: graphql`
    fragment RecipeInfo_recipe on RecipeNode {
      isTrend
      name
      description
      category {
        name
      }
      labels {
        edges {
          node {
            id
            name
          }
        }
      }
      mediaFiles {
        edges {
          node {
            id
            mediaUrl
          }
        }
      }
      medRatings
      totalRatings
      difficulty
      serves
      time
    }
  `,
});
